/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface ProductBase
 */
export interface ProductBaseOptional {
  /**
   *
   * @type {string}
   * @memberof ProductBase
   */
  productName?: string;
  /**
   *
   * @type {string}
   * @memberof ProductBase
   */
  productDescription?: string;
  /**
   *
   * @type {boolean}
   * @memberof ProductBase
   */
  active?: boolean;
}

export interface ProductBase extends ProductBaseOptional {
  /**
   *
   * @type {string}
   * @memberof ProductBase
   */
  productName: string;
  /**
   *
   * @type {string}
   * @memberof ProductBase
   */
  productDescription: string;
  /**
   *
   * @type {boolean}
   * @memberof ProductBase
   */
  active: boolean;
}

export interface ProductBaseTrackedI {
  /**
   *
   * @type {string}
   * @memberof ProductBase
   */
  productName?: string;
  productNameIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ProductBase
   */
  productDescription?: string;
  productDescriptionIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ProductBase
   */
  active?: boolean;
  activeIsSet: boolean;
}

transformDatesMap.set("ProductBase", function (model: ProductBase) {});

export type ProductBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  productName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  productDescription: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  active: PropertyMeta<MetaTypeBase<boolean>>;
}>;

export var ProductBaseMeta: ProductBaseMetaI = {} as ProductBaseMetaI;
ProductBaseMeta = typeMeta("ProductBase", {
  productName: propertyMeta(
    "productName",
    false,
    true,
    false,
    MetaTypesBase.string,
  ),
  productDescription: propertyMeta(
    "productDescription",
    false,
    true,
    false,
    MetaTypesBase.string,
  ),
  active: propertyMeta("active", false, true, false, MetaTypesBase.boolean),
});

const metaI = ProductBaseMeta;

registerMeta(() => {});

export class ProductBaseTracked implements ProductBaseTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  productName__I?: string = undefined;
  productNameIsSet: boolean = false;
  set productName(v: undefined | string) {
    if (v !== undefined) {
      this.productName__I = v;
      this.productNameIsSet = true;
    } else {
      this.productName__I = v || undefined;
      this.productNameIsSet = true;
    }
    this.changeTracker = true;
  }
  get productName() {
    return this.productName__I;
  }
  productDescription__I?: string = undefined;
  productDescriptionIsSet: boolean = false;
  set productDescription(v: undefined | string) {
    if (v !== undefined) {
      this.productDescription__I = v;
      this.productDescriptionIsSet = true;
    } else {
      this.productDescription__I = v || undefined;
      this.productDescriptionIsSet = true;
    }
    this.changeTracker = true;
  }
  get productDescription() {
    return this.productDescription__I;
  }
  active__I?: boolean = undefined;
  activeIsSet: boolean = false;
  set active(v: undefined | boolean) {
    if (v !== undefined) {
      this.active__I = v;
      this.activeIsSet = true;
    } else {
      this.active__I = v || undefined;
      this.activeIsSet = true;
    }
    this.changeTracker = true;
  }
  get active() {
    return this.active__I;
  }
  constructor(config?: ProductBaseOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: ProductBaseOptional,
    options?: AssignOptions,
  ): ProductBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.productName &&
      this.productNameApplyFilter(optionsRequired.filter)
    ) {
      this.productName = config.productName;
      if (optionsRequired.unassign) this.productNameIsSet = false;
      else this.productNameIsSet = true;
    }
    if (
      config.productDescription &&
      this.productDescriptionApplyFilter(optionsRequired.filter)
    ) {
      this.productDescription = config.productDescription;
      if (optionsRequired.unassign) this.productDescriptionIsSet = false;
      else this.productDescriptionIsSet = true;
    }
    if (config.active && this.activeApplyFilter(optionsRequired.filter)) {
      this.active = config.active;
      if (optionsRequired.unassign) this.activeIsSet = false;
      else this.activeIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): ProductBaseTrackedI {
    const cloned = {} as ProductBaseTrackedI;
    if (
      this.productNameIsSetDeep() &&
      this.productNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.productNameIsSet = true;
      cloned.productName = this.productName;
    } else {
      //cloned.productNameIsSet = false
    }
    if (
      this.productDescriptionIsSetDeep() &&
      this.productDescriptionApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.productDescriptionIsSet = true;
      cloned.productDescription = this.productDescription;
    } else {
      //cloned.productDescriptionIsSet = false
    }
    if (
      this.activeIsSetDeep() &&
      this.activeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.activeIsSet = true;
      cloned.active = this.active;
    } else {
      //cloned.activeIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): ProductBaseTrackedI {
    if (!this.productNameApplyFilter(filter)) this.productNameIsSet = false;

    if (!this.productDescriptionApplyFilter(filter))
      this.productDescriptionIsSet = false;

    if (!this.activeApplyFilter(filter)) this.activeIsSet = false;

    return this;
  }
  productNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ProductBaseMeta.productName,
      ProductBaseMeta,
      this.productName,
      this,
    );
  }
  productNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.productNameIsSet && this.productNameApplyFilter(filter))
      return true;

    return false;
  }
  productDescriptionApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ProductBaseMeta.productDescription,
      ProductBaseMeta,
      this.productDescription,
      this,
    );
  }
  productDescriptionIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.productDescriptionIsSet &&
      this.productDescriptionApplyFilter(filter)
    )
      return true;

    return false;
  }
  activeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(ProductBaseMeta.active, ProductBaseMeta, this.active, this);
  }
  activeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.activeIsSet && this.activeApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.productNameIsSetDeep(filter)) return true;
    if (this.productDescriptionIsSetDeep(filter)) return true;
    if (this.activeIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
